import Service, { service } from '@ember/service';
import type FetchService from '@triptyk/ember-utils/services/fetch';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import type IntlService from 'ember-intl/services/intl';
import type CurrentUserService from '../current-user';
import { IntraFormChangeset } from 'frontend/changesets/intra';

export default class IntraFormChangesetService extends Service {
  @service declare fetch: FetchService;
  @service declare flashMessages: FlashMessageService;
  @service declare intl: IntlService;
  @service declare currentUser: CurrentUserService;

  async sendIntraForm(changeset: IntraFormChangeset) {
    changeset.execute();
    const changesetData = changeset.data;

    const body = {
      type: changesetData.type,
      name: changesetData.name,
      targetAudience: changesetData.targetAudience,
      title: changesetData.title,
      email: changesetData.email,
      phone: changesetData.phone,
      message: changesetData.message,
    };

    try {
      await this.fetch.request('contact/intra', {
        method: 'POST',
        body: JSON.stringify(body),
      });
      this.flashMessages.success(
        this.intl.t('components.modals.exit-modal.success_message')
      );
    } catch (e) {
      this.flashMessages.alert(
        this.intl.t('components.modals.exit-modal.fail_message')
      );
    }
  }

  emptyChangeset() {
    const user = this.currentUser.user;

    return new IntraFormChangeset({
      type: '',
      title: '',
      name: '',
      targetAudience: undefined,
      email: user?.email ?? '',
      phone: user?.phone ?? '+32',
      message: '',
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'changesets/intra-form': IntraFormChangesetService;
  }
}
